import { render, staticRenderFns } from "./checkbox-primary.vue?vue&type=template&id=73ba1080&scoped=true"
import script from "./checkbox-primary.vue?vue&type=script&lang=js"
export * from "./checkbox-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ba1080",
  null
  
)

export default component.exports